import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';

interface CustomHeadingProps {
  heading1: string;
  heading2: string;
  headingTag?: 'h1' | 'h2';
  className?: {
    wrapper?: string;
  };
}

const CustomHeading = (props: CustomHeadingProps) => {
  const HeadingTag = props.heading2.trim() ? (props.headingTag ?? 'h2') : 'span';
  return (
    <div
      className={cn(
        'flex h-full flex-col items-center justify-center gap-x-5 md:flex-row md:pl-[50px]',
        'ea-custom-heading__wrapper',
        props.className?.wrapper,
      )}
    >
      {/* heading 1 */}
      <span
        className={cn(
          'text-lg font-semibold text-[#3344FF] md:text-xl',
          'ea-custom-heading__heading-1',
        )}
      >
        {props.heading1}
      </span>
      {/* separator  */}
      <div
        className={cn(
          'hidden h-[30px] w-[2px] bg-[#FF3339] md:block',
          'ea-custom-heading__separator-1',
        )}
      ></div>
      <div
        className={cn(
          'mb-3 mt-5 h-[2px] w-full max-w-[40px] bg-[#FF3339] md:hidden',
          'ea-custom-heading__separator-2',
        )}
      ></div>
      {/* heading 2 */}
      <HeadingTag data-ea-visual-tag="span"
        className={cn(
          'text-center text-[24px] font-semibold text-black md:text-[32px]',
          'ea-custom-heading__heading-2',
        )}
      >
        {props.heading2}
      </HeadingTag>
    </div>
  );
};

export default CustomHeading;
